import { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "@/lib/firebase";

export interface League {
  id: string;
  team: string;
  divisionUrl: string;
  divisionName: string;
  opponents: string[];
}

export function useLeagues(clubId: string | undefined) {
  const [leagues, setLeagues] = useState<League[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clubId) {
      setLeagues([]);
      setLoading(false);
      return;
    }

    const unsub = onSnapshot(
      collection(db, "clubs", clubId, "leagues"),
      (snap) => {
        const items = snap.docs.map((d) => ({
          id: d.id,
          ...d.data(),
        })) as League[];
        setLeagues(items);
        setLoading(false);
      }
    );

    return unsub;
  }, [clubId]);

  // Get all unique opponents across all leagues
  const allOpponents = [...new Set(leagues.flatMap((l) => l.opponents))].sort();

  // Get opponents for a specific team
  const getOpponentsForTeam = (team: string) => {
    const league = leagues.find((l) => l.team === team);
    return league?.opponents || [];
  };

  return { leagues, allOpponents, getOpponentsForTeam, loading };
}
